// The initial values snapshot on a Niko patient detail reliably carries only EligibilityStatusId.
// The EligibilityStatus object is written only when the entity that produced the snapshot happened
// to have the navigation loaded, so records written by any other path (the BT -> Niko data
// migration, the Create New Patient flow) hold the id with no name and render as "Empty".
// Resolve the name from the id; "Empty" then means only that no initial id was saved (ISG-2882).
export default function resolveInitialEligibilityStatus(initialNikoPatientDetail, eligibilityStatuses) {
    if (!initialNikoPatientDetail || initialNikoPatientDetail.EligibilityStatus || !initialNikoPatientDetail.EligibilityStatusId) return;
    const eligibilityStatus = (eligibilityStatuses || []).find(s => s.id === initialNikoPatientDetail.EligibilityStatusId);
    if (eligibilityStatus) initialNikoPatientDetail.EligibilityStatus = { Name: eligibilityStatus.name };
}
